export default "__VITE_ASSET__BO9oIh6K__"